import { Component, OnInit } from '@angular/core';
import { EditEntityBaseClass } from '../EditEntityBaseClass';
import { PsalterService, Psalter } from '../../services/psalter.service';
import { LectionarySourceService, LectionarySource } from '../../services/lectionary-source.service';
import { MatDialogRef } from '@angular/material/dialog';
import { htmlAstToRender3Ast } from '@angular/compiler/src/render3/r3_template_transform';

@Component({
  selector: 'app-psalter-edit',
  templateUrl: './psalter-edit.component.html',
  styleUrls: ['./psalter-edit.component.css']
})
export class PsalterEditComponent extends EditEntityBaseClass  implements OnInit {

  public item: Psalter;
  public listsLoaded: boolean;
  public lectionarySources: LectionarySource[];
 
  public headerTitle = "Add Psalter";
  public saveButtonText = "Save";
  public htmlEditedValue: string; //using this as a temporary variable for the results from the editor, until we're ready to save.


  constructor(
    private psalterSvc: PsalterService,
    private lectionarySourceSvc: LectionarySourceService, 
    private dialog: MatDialogRef<PsalterEditComponent>
    ) { 
    super();
  }

  ngOnInit() {
    this.listsLoaded = true;

    this.getValues();
  }

  public setModal(psalterId: number) {

    if (psalterId == null) {
        this.headerTitle = "Add Psalter"; 

        this.item = new Psalter();    
    } else {
      this.headerTitle = "Edit Psalter";

      //Get the psalter from the API
      this.psalterSvc.getItem(psalterId).then(
        (s: Psalter) => {
          console.log("Loaded", s);
          this.item = s;

          this.htmlChanged(s.Localized[0].Html)
        }
      )
    }
  }

  private getValues() {
    
    var lectionarySourcePromise = this.lectionarySourceSvc.loadEntites().then(
      (data) => {
        this.lectionarySources = data;
      }
    )

  }

  public htmlChanged(e) { 
    this.htmlEditedValue = e; 
  }

  public cancel() {
    this.dialog.close();
  }

  public save(isProofed: boolean) {
  
    if (this.htmlEditedValue == "" || this.htmlEditedValue == undefined) {
      alert("Cannot save with an empty HTML field");
      return;
    }

    this.CurrentLocalizedData().Html = this.htmlEditedValue;

    console.log("Saving psalter", this.item, isProofed);
      
    this.psalterSvc.save(this.item, isProofed).then(
      (s) => { 
        console.log("Saved", s);
        this.dialog.close(s);
      }
    ).catch((ex) => {
      console.log(ex);

      var msg = ex;

      if (ex.Message != undefined) {
        var msg = ex.Message.split("|").join("\n"); 
      }

      alert("There was an error while saving the Psalter\n\n" + msg);
    });
  }

}
